import { apiClient } from './config';

/**
 * Get traffic lights within bounding box
 */
export const getTrafficLights = async (bbox) => {
  const response = await apiClient.get(`/traffic_lights?bbox=${bbox}`);
  return response.data;
};

/**
 * Fetch all signals
 */
export const fetchSignals = async () => {
  const response = await apiClient.get('/signal/all');
  return response.data;
};

/**
 * Create new traffic signal
 */
export const createSignal = async (formData) => {
  const response = await apiClient.post('/signal', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
  return response.data;
};

/**
 * Update existing traffic signal
 */
export const updateSignal = async (formData, id) => {
  const response = await apiClient.put(`/signal/${id}`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
  return response.data;
};

/**
 * Delete traffic signal
 */
export const deleteSignal = async (id) => {
  const response = await apiClient.delete(`/signal/${id}`);
  return response.data;
};
